export const FulfillmentInstructions = {
    getAvailableFulfillmentMethod(fulfillmentMethodType, fulfillmentMethods) {
        return fulfillmentMethods.includes(fulfillmentMethodType)
            ? fulfillmentMethodType
            : fulfillmentMethods.get(0);
    },
};
export const FulfillmentInstructionsToken = "FulfillmentInstructions";
